/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create an AI token usage record
 * @export
 * @interface CreateAiTokenUsageRequest
 */
export interface CreateAiTokenUsageRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateAiTokenUsageRequest
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAiTokenUsageRequest
     */
    source: CreateAiTokenUsageRequestSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateAiTokenUsageRequest
     */
    tokensUsed: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAiTokenUsageRequest
     */
    relatedId?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAiTokenUsageRequest
     */
    relatedType?: string;
}


/**
 * @export
 */
export const CreateAiTokenUsageRequestSourceEnum = {
    DocParse: 'doc_parse',
    Compare: 'compare',
    Supplement: 'supplement',
    Other: 'other'
} as const;
export type CreateAiTokenUsageRequestSourceEnum = typeof CreateAiTokenUsageRequestSourceEnum[keyof typeof CreateAiTokenUsageRequestSourceEnum];


/**
 * Check if a given object implements the CreateAiTokenUsageRequest interface.
 */
export function instanceOfCreateAiTokenUsageRequest(value: object): value is CreateAiTokenUsageRequest {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('tokensUsed' in value) || value['tokensUsed'] === undefined) return false;
    return true;
}

export function CreateAiTokenUsageRequestFromJSON(json: any): CreateAiTokenUsageRequest {
    return CreateAiTokenUsageRequestFromJSONTyped(json, false);
}

export function CreateAiTokenUsageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAiTokenUsageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'source': json['source'],
        'tokensUsed': json['tokensUsed'],
        'relatedId': json['relatedId'] == null ? undefined : json['relatedId'],
        'relatedType': json['relatedType'] == null ? undefined : json['relatedType'],
    };
}

export function CreateAiTokenUsageRequestToJSON(json: any): CreateAiTokenUsageRequest {
    return CreateAiTokenUsageRequestToJSONTyped(json, false);
}

export function CreateAiTokenUsageRequestToJSONTyped(value?: CreateAiTokenUsageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'source': value['source'],
        'tokensUsed': value['tokensUsed'],
        'relatedId': value['relatedId'],
        'relatedType': value['relatedType'],
    };
}

